import React, { useState, useEffect } from 'react';
import NotFoundSvg from '../img/not_found.svg';

function NotFoundPage() {
  return (
    <div className={"flex-1 content-center max-w-screen-md md:m-auto mt-24 md:mt-24"}>
      <div className="m-auto w-6/12">
        <img className={""} src={NotFoundSvg} alt="404 Not Found" />

        <div className={"text-center mt-6"}>
          Page Not Found
        </div>
        
      </div>

      
    </div>
  )
}

export default NotFoundPage;